import {Link} from 'react-router-dom'
import styled from 'styled-components'

export const LinkEl = styled(Link)`
  text-decoration: none;
  width: 30%;
`

export const HomeVideoItem = styled.li`
  margin: 0 20px 50px 0;
`

export const ThumbnailImg = styled.img`
  width: 100%;
`

export const ChannelImgAndAboutVideoContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 10px;
`

export const ChannelImg = styled.img`
  width: 40px;
`

export const AboutVideoContainer = styled.div`
  margin-left: 14px;
`

export const VideoTitle = styled.p`
  font-size: 19px;
  font-weight: 500;
  margin: 0 0 8px 0;
  color: ${props => (props.darkMode ? '#f1f5f9' : '#0f0f0f')};
`

export const ChannelName = styled.p`
  color: #64748b;
  margin: 4px 6px 0 0;
  font-size: 14px;
`

export const ViewsAndDurationContainer = styled.div`
  display: flex;
  margin-top: 10px;
`

export const ViewsCnt = styled.p`
  margin: 0;
  color: #64748b;
  font-size: 14px;
`

export const Duration = styled.p`
  margin: 0 0 0 16px;
  color: #64748b;
  font-size: 14px;
`
